export default __webpack_public_path__ + "static/media/objectifs.33e68aaf.svg";